import React from 'react';
import IconFlood from 'ta-react-iconflood';

const oscarStatue = require('../oscar.svg');
const oscarStatueOutline = require('../oscar-outline.svg');

function MostAwarded(props) {
  return (
    <div
      className={props.Columns == 1 ? 'ui center aligned column' : 'ui center aligned two columns'}
    >

      <h2 className={props.Columns == 1 ? 'ui center aligned small header narrow' : 'ui center aligned header'}>
        {props.Film}
        <div className='sub header'>
          {props.Metadata}
        </div>
      </h2>

      <IconFlood count={parseInt(props.Oscars, 10)}
                 imageSrc={oscarStatue}
                 size='mini' inline/>&ensp;
      <IconFlood
        count={parseInt(props.Nominierungen, 10) - parseInt(props.Oscars, 10)}
        imageSrc={oscarStatueOutline}
        size='mini oscar-image' inline
        style={{marginLeft: '0.25em', maxWidth: '15px'}}
      />
      {props.Columns > 1 &&
        <p
          style={{
            color: 'rgba(0, 0, 0, 0.6)'
          }}
        >gewann <strong>{props.Oscars} Oscars</strong> von insgesamt {props.Nominierungen} Nominierungen</p>
      }
      <div className='ui divider'></div>
    </div>
  )
}

MostAwarded.propTypes = {
  Film: React.PropTypes.string.isRequired,
  Metadata: React.PropTypes.string,
  Oscars: React.PropTypes.string.isRequired,
  Nominierungen: React.PropTypes.string.isRequired,
  Columns: React.PropTypes.number
};

export default MostAwarded;



// WEBPACK FOOTER //
// ./src/components/main/mostAwarded/index.js